export const CountriesData = [
  {label: "+91", value: "91", flag: "in"},
  {label: "+1", value: "1", flag: "us"},
  {label: "+974", value: "974", flag: "qa"}
  // {label: "+65", value: "65", flag: "sg"},
  // {label: "+60", value: "60", flag: "my"},
  // {label: "+63", value: "63", flag: "ph"}
];
